import { FC } from "react";
import SmartSearchMonthYearAndActionsLayout from "../../../components/Layouts/smart-search-month-year-and-actions-layout";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import {
  GetLocationInventoryParams,
  getLocationInventory,
} from "../../../services/reports";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";
import {SearchStatusEnum} from "../../../enums/searchStatusEnum";
import dayjs from "dayjs";

const ReportSiteInventory: FC = () => {
  return (
    <SmartSearchMonthYearAndActionsLayout
      searchBy={[
        SearchOptionEnum.CHARITY,
        SearchOptionEnum.LOCATION,
      ]}
      status={SearchStatusEnum.ACTIVE + "," + SearchStatusEnum.CLOSED}
      minYear={2014}
      validOnEmpty={false}
      actions={[
        ActionButtonEnum.REFRESH,
        ActionButtonEnum.SAVE_CSV,
        ActionButtonEnum.SAVE_PDF,
      ]}
      onRefresh={(output, month, year, params) => {
        const getLocationInventoryParams: GetLocationInventoryParams = {
          name: "Location Inventory",
          output,
          fullMonth: dayjs()
            .set("date", 1)
            .set("year", Number(year))
            .set("month", Number(month))
            .format("YYYY-MM-DD"),
        };

        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getLocationInventoryParams[id] = params.id;
        }

        return getLocationInventory(getLocationInventoryParams);
      }}
    />
  );
};

export default ReportSiteInventory;
